const messages = {
  en: {
    hello: 'hello world',
    register: 'Register',
    join_now: 'Join Now',
    select_stream_below: 'Please select preferred stream below',
    please_write_your_question: 'Please write your question',
    change: 'Change',
    save: 'Save',
    cancel: 'Cancel',
    send: 'Send',
    name: 'Name',
    city_or_country: 'City or Country',
    please_register: 'Please register for:',
    please_wait: 'Please wait',
    please_enter_your_name: "Please enter your name and location before sending a question.",
    hide_questions: "Questions are only visible to speaker",
  },
}

export default messages